export default __webpack_public_path__ + "static/media/logo-white.bc586044.svg";